// Import React and TertiaryButton styles
import React from "react";
import "../../../css/components/buttons/TertiaryButton.css";

// TertiaryButton component renders a stylized button for "See More" actions
// children: Button label (defaults to "SEE MORE")
// onClick: Function to call when button is clicked
const TertiaryButton = ({ children = "SEE MORE", onClick, color = "" }) => (
  <button className="tertiary-btn" onClick={onClick}>
    {/* Decorative line element for visual style */}
    <span className={`tertiary-line ${color}`} />
    {/* Button text, customizable via children prop */}
    <span className="tertiary-text nav-regualar primary">{children}</span>
  </button>
);

// Export the TertiaryButton component for use in other parts of the app
export default TertiaryButton;
